import { isNearBlack, isNearWhite } from "../comparisonUtils/index.js";
import { gradientFromDarkColor } from "./gradientFromDarkColor.js";
import { gradientFromLightColor } from "./gradientFromLightColor.js";
import { gradientFromMiddleColor } from "./gradientFromMiddleColor.js";

/**
 * @param {object} param
 * @param {string} param.color - The color to generate the gradient from
 * @param {number} param.steps - The number of steps in the gradient
 * @param {string} param.outputFormat - The format of the output color
 * @returns
 */
export function monochromatic({ color, steps = 3, outputFormat = "hex" }) {
  if (!color) throw new Error("A color is required");
  if (typeof color !== "string") throw new Error("Color must be a string");
  if (typeof steps !== "number") throw new Error("Steps must be a number");
  if (steps < 2) throw new Error("Steps must be greater than 1");

  if (outputFormat && typeof outputFormat !== "string")
    throw new Error("Outbound format must be a string");

  // dark gradients start with the selected color and move lighter
  const isDark = isNearBlack({ color });
  if (isDark) return gradientFromDarkColor({ color, steps, outputFormat });

  // light gradients start with the darkest color and end with the selected color
  const isLight = isNearWhite({ color });
  if (isLight) return gradientFromLightColor({ color, steps, outputFormat });

  // if the color is neither dark nor light, the selected color is the middle color and we generate darker and lighter steps around it
  return gradientFromMiddleColor({ color, steps, outputFormat });
}
